{
  "buttons": {
    "newAlbum": "New Album",
    "reprocessFaces": "Re-run Facial Recognition"
  },
  "toasts": {
    "deleteSuccess": "Album successfully deleted.",
    "deleteFailure": "Something went wrong, your album could not be deleted. Please try again.",
    "reprocessFacesSuccess": "Facial recognition re-processing started for {{count}} photo(s). Tags will appear shortly.",
    "reprocessFacesFailure": "Could not start facial-recognition reprocessing. Please try again."
  },
  "confirmations": {
    "delete": {
      "title": "Delete Album",
      "description": "Are you sure? You can't undo this action afterwards.",
      "buttonConfirmation": "Delete"
    },
    "reprocessFaces": {
      "title": "Re-run Facial Recognition?",
      "description": "This re-runs facial recognition on every photo in this album. It is a paid, per-image operation that costs money, so only use it to recover an album that failed to tag. Do you want to continue?",
      "buttonConfirmation": "Re-run Recognition"
    },
    "sort": {
      "title": "Change sort order",
      "description": "Replace your custom order with ",
      "buttonConfirmation": "Sort"
    }
  }
}
